module.exports = __webpack_public_path__ + "static/media/car-2-goldcoast.02ecfc42.png";